/*  MUI  */
import { Box } from '@mui/material';

/*  Shared  */
import { Sidebar } from 'application/Shared/Views/Components/Sidebar/Sidebar';

/* Hooks */
import { useSession } from 'hooks/redux/Selectors/session';

/*  React  */
import React from 'react';

import { TenantLoader } from './TenantLoader';

export const AdminView = (props) => {
    const { onlyShowChildrenElements, children, page, className = '' } = props;

    const session = useSession();
    if (!session) {
        return null;
    }

    if (onlyShowChildrenElements) {
        return children;
    }

    return (
        <TenantLoader>
            <Box
                data-testid="sharedComponentsAdminView"
                display="flex"
                width="100%"
            >
                <Sidebar adminView page={page} />
                <Box id="mainViewContainer" className={className}>
                    {children}
                </Box>
            </Box>
        </TenantLoader>
    );
};
